export default Object.freeze({
	NOT_STARTED: 1,
	IN_PROGRESS: 2,
	APPROVED: 3,
	REJECTED: 4,
});